import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import userService from "../services/userService";
import { Checkbox } from "primereact/checkbox";

export default class Profile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    async componentDidMount() {
        try {
            await showProcess();

            if (UserSession !== null && UserSession !== undefined && UserSession !== "") {
                const response = await userService.getById(UserSession.id);

                if (response.status === 200) {
                    this.setState({ user: response.data });
                } else {
                    alert("ERRO AO CARREGAR PAGINA");
                }
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    formatarTelefone(telefone) {
        telefone = telefone.replace(/\D/g, "");

        // Verifica se tem DDD
        if (telefone.length <= 10) {
            // Formato: (XX) XXXX-XXXX
            return telefone.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        } else {
            // Formato: (XX) XXXXX-XXXX
            return telefone.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
        }
    }

    render() {
        if (UserSession === null || UserSession === undefined || UserSession === "") {
            window.location.href = "/login";
            return;
        }
        if (this.state.user !== undefined)
            return (
                <div
                    style={{
                        padding: window.innerWidth < 768 ? "15px" : "40px",
                        overflowX: "hidden",
                        width: "100%",
                        boxSizing: "border-box",
                    }}
                >
                    {/* Links de navegação */}
                    <div
                        style={{
                            textAlign: window.innerWidth < 768 ? "center" : "left",
                            fontSize: window.innerWidth < 768 ? "0.9em" : "1em",
                            marginBottom: "20px",
                        }}
                    >
                        <a href="/" style={{ color: "#209ADB", textDecoration: "underline" }}>
                            Home
                        </a>
                        <span style={{ margin: "0 10px" }} />
                        <a style={{ color: "#209ADB", textDecoration: "underline" }}>
                            Configurações
                        </a>
                        <span style={{ margin: "0 10px" }} />
                        <a
                            href="/profile"
                            style={{ color: "#209ADB", textDecoration: "underline" }}
                        >
                            Meu Perfil
                        </a>
                    </div>

                    {/* Perfil e nome */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: window.innerWidth < 768 ? "30px" : "60px",
                        }}
                    >
                        <div
                            style={{
                                padding: "10px",
                                border: "2px solid #ACACAC",
                                borderRadius: "50%",
                                width: window.innerWidth < 768 ? "70px" : "90px",
                                height: window.innerWidth < 768 ? "70px" : "90px",
                                textAlign: "center",
                                marginBottom: "20px",
                            }}
                        >
                            <span
                                className="pi pi-user"
                                style={{
                                    fontSize: window.innerWidth < 768 ? "40px" : "60px",
                                    color: "#ACACAC",
                                }}
                            />
                        </div>
                        <label
                            style={{
                                fontSize: window.innerWidth < 768 ? "1.8em" : "66px",
                                color: "#5D5D5D",
                                fontFamily: "var(----unnamed-font-family-helvetica-neue)",
                                textAlign: "center",
                                wordBreak: "break-word",
                                maxWidth: "90%",
                            }}
                        >
                            {this.state.user.name}
                        </label>
                    </div>

                    {/* Container principal com tabelas */}
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            display: window.innerWidth < 992 ? "block" : "table",
                        }}
                        cellSpacing={window.innerWidth < 768 ? 20 : 50}
                    >
                        <tr
                            style={{
                                display: window.innerWidth < 992 ? "flex" : "table-row",
                                flexDirection: window.innerWidth < 992 ? "column" : "row",
                                gap: window.innerWidth < 992 ? "20px" : "0",
                            }}
                        >
                            {/* Coluna 1 */}
                            <td
                                style={{
                                    verticalAlign: "top",
                                    width: window.innerWidth < 992 ? "100%" : "33%",
                                    display: window.innerWidth < 992 ? "block" : "table-cell",
                                }}
                            >
                                <div
                                    style={{
                                        boxShadow: "0px 0px 6px #00000029",
                                        borderRadius: "19px",
                                        padding: "20px",
                                        color: "#707070",
                                        minWidth: window.innerWidth < 768 ? "auto" : "300px",
                                    }}
                                >
                                    <table
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: "100%" }}
                                    >
                                        <tr>
                                            <td>
                                                <label
                                                    style={{ fontWeight: "bold", fontSize: "22px" }}
                                                >
                                                    Informações de contato
                                                </label>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <label
                                                    style={{
                                                        fontWeight: "bold",
                                                        fontSize: "22px",
                                                        color: "red",
                                                    }}
                                                >
                                                    Alterar
                                                </label>
                                            </td>
                                        </tr>
                                    </table>
                                    <hr style={{ borderColor: "#00000029", margin: "20px 0px" }} />
                                    {[
                                        { label: "Nome:", value: this.state.user.name },
                                        { label: "E-mail:", value: this.state.user.email },
                                        {
                                            label: "Celular:",
                                            value: this.formatarTelefone(this.state.user.phone),
                                        },
                                        {
                                            label: "Telefone comercial:",
                                            value: this.formatarTelefone(this.state.user.phone),
                                        },
                                    ].map((item, i) => (
                                        <span
                                            key={i}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "10px",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            <label style={{ fontWeight: "bold", fontSize: "22px" }}>
                                                {item.label}
                                            </label>
                                            <label style={{ fontSize: "22px" }}>{item.value}</label>
                                        </span>
                                    ))}
                                </div>
                            </td>

                            {/* Coluna 2 */}
                            <td
                                style={{
                                    verticalAlign: "top",
                                    width: window.innerWidth < 992 ? "100%" : "33%",
                                    display: window.innerWidth < 992 ? "block" : "table-cell",
                                }}
                            >
                                <div
                                    style={{
                                        boxShadow: "0px 0px 6px #00000029",
                                        borderRadius: "19px",
                                        padding: "20px",
                                        color: "#707070",
                                        marginBottom: "30px",
                                        minWidth: window.innerWidth < 768 ? "auto" : "300px",
                                    }}
                                >
                                    <table
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: "100%" }}
                                    >
                                        <tr>
                                            <td>
                                                <label
                                                    style={{ fontWeight: "bold", fontSize: "22px" }}
                                                >
                                                    Senha
                                                </label>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <label
                                                    style={{
                                                        fontWeight: "bold",
                                                        fontSize: "22px",
                                                        color: "red",
                                                    }}
                                                >
                                                    Alterar
                                                </label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                {/*<div
          style={{
            boxShadow: '0px 0px 6px #00000029',
            borderRadius: '19px',
            padding: '20px',
            color: '#707070',
            minWidth: window.innerWidth < 768 ? 'auto' : '300px'
          }}
        >
          
          <table cellPadding={0} cellSpacing={0} style={{ width: '100%' }}>
            <tr>
              <td>
                <label style={{ fontWeight: 'bold', fontSize: '22px' }}>Endereço</label>
              </td>
              <td style={{ textAlign: 'right' }}>
                <label style={{ fontWeight: 'bold', fontSize: '22px', color: 'red' }}>Alterar</label>
              </td>
            </tr>
          </table>
          <hr style={{ borderColor: '#00000029', margin: '20px 0px' }} />
          <table>
            <tr>
              <td style={{ verticalAlign: 'top', width: '50px', lineHeight: '40px' }}>
                <span className="pi pi-map-marker" style={{ fontSize: '22px' }} />
              </td>
              <td style={{ verticalAlign: 'top' }}>
                <label style={{ fontWeight: 'bold', fontSize: '22px', lineHeight: '40px' }}>Casa</label>
                <br />
                <label style={{ lineHeight: '30px', fontSize: '18px' }}>
                  Rua Professora Francisca de Queiroz, <br />
                  614 Vila Independência, <br />
                  Sorocaba - SP <br />
                  CEP: 18040-325
                </label>
              </td>
            </tr>
          </table>
          
        </div>*/}
                            </td>

                            {/* Coluna 3 */}
                            <td
                                style={{
                                    verticalAlign: "top",
                                    width: window.innerWidth < 992 ? "100%" : "33%",
                                    display: window.innerWidth < 992 ? "block" : "table-cell",
                                }}
                            >
                                <div
                                    style={{
                                        boxShadow: "0px 0px 6px #00000029",
                                        borderRadius: "19px",
                                        padding: "20px",
                                        color: "#707070",
                                        minWidth: window.innerWidth < 768 ? "auto" : "300px",
                                    }}
                                >
                                    <table
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: "100%" }}
                                    >
                                        <tr>
                                            <td>
                                                <label
                                                    style={{ fontWeight: "bold", fontSize: "22px" }}
                                                >
                                                    Comunicações
                                                </label>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <label
                                                    style={{
                                                        fontWeight: "bold",
                                                        fontSize: "22px",
                                                        color: "red",
                                                    }}
                                                >
                                                    Alterar preferências
                                                </label>
                                            </td>
                                        </tr>
                                    </table>
                                    <hr style={{ borderColor: "#00000029", margin: "20px 0px" }} />
                                    <label style={{ fontSize: "20px" }}>
                                        Escolha como você prefere receber informações, novidades,
                                        ofertas e recomendações personalizadas:
                                    </label>
                                    <table style={{ marginTop: "20px" }}>
                                        {[
                                            { text: "E-mail", checked: true },
                                            { text: "SMS (Mensagem de texto)", checked: true },
                                            {
                                                text: "Notificação do aplicativo (Push)",
                                                checked: false,
                                            },
                                            { text: "WhatsApp", checked: false },
                                        ].map((opt, i) => (
                                            <tr key={i} style={{ height: "40px" }}>
                                                <td>
                                                    <Checkbox checked={opt.checked} />
                                                </td>
                                                <td>
                                                    <label style={{ fontSize: "22px" }}>
                                                        {opt.text}
                                                    </label>
                                                </td>
                                            </tr>
                                        ))}
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            );
    }
}
